<template>
  <div class="vertical-center">
    <div v-if="value !== null">
      <vs-button class="float-left mr-2" @click="popupActive=true" type="filled" color="primary" size="small">Show QR</vs-button>
    </div>

    <vs-popup class="holamundo"  title="Scan this QR with dedicated device" :active.sync="popupActive">
      <vue-qrcode class="width-100" :value="value" :width="width"/>
      <p>{{value}}</p>
    </vs-popup>
  </div>
</template>

<script>
  import Vue from "vue";
  import VueQrcode from 'vue-qrcode'

  export default Vue.extend({
    name: 'DeviceRequestShowQR',
    components: { VueQrcode },
    data() {
      return {
        value: '',
        width: 300,
        popupActive:false,
        camera: 'off',
        result: null,
        showScanConfirmation: false,
      }
    },
    methods: {
      
    },
    mounted() {
      if (this.params.value) {
        this.value = this.params.value
      }
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .width-100 {
    width: 100%;
  }
</style>

